import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSplit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSplit"><Path fillRule="evenodd" clipRule="evenodd" d="M13 2V22H11V2H13ZM2 4H9V20H2V4ZM15 4H22V20H15V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSplit;
